import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs13 fw600" }, "過去に利用したタイトル:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { class: "fw600 ml10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fl mr5" }, "サブタイトル", -1)
const _hoisted_12 = { class: "fl fs13" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 2,
  class: "w100 mt20"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "所要時間", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear mb20" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 3,
  class: "fl w70"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "確定できるユーザー", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = { key: 4 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "fs9" }
const _hoisted_30 = {
  key: 0,
  class: "fw900"
}
const _hoisted_31 = {
  key: 0,
  class: "fr"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { style: {} }, "登録済みの場所から選択する", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = { key: 2 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_38 = {
  key: 0,
  class: "label skyblueBorder centered",
  style: {"font-size":"10.5px"}
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = { key: 3 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "fs13 fw600" }, "過去に利用した場所:", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { key: 5 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "メモ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_LblueListContent = _resolveComponent("LblueListContent")!
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_MeetingTimeContent = _resolveComponent("MeetingTimeContent")!
  const _component_AvailableStepSizeContent = _resolveComponent("AvailableStepSizeContent")!
  const _component_AvailableDaysOfWeeksTable = _resolveComponent("AvailableDaysOfWeeksTable")!
  const _component_MeetingSpanContent = _resolveComponent("MeetingSpanContent")!
  const _component_FixTypeButtons = _resolveComponent("FixTypeButtons")!
  const _component_LocationIcon = _resolveComponent("LocationIcon")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_SelectLocationsModal = _resolveComponent("SelectLocationsModal")!

  return (_ctx.currentAppo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (_ctx.openSubTitleView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h5", {
                  class: "fw600 pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickOpenSubTitleView && _ctx.clickOpenSubTitleView(...args)))
                }, "サブタイトル"),
                _hoisted_3,
                _createVNode(_component_TextfieldTag, {
                  placeholder: "一次面接",
                  style: {"height":"50px","min-width":"280px"},
                  class: "fl fs14 roundForm",
                  value: _ctx.getTitle(),
                  onInputValue: _ctx.inputTitle
                }, null, 8, ["value", "onInputValue"]),
                (_ctx.titles)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                      _hoisted_5,
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titles, (title, locindex) => {
                        return (_openBlock(), _createBlock(_component_LblueListContent, {
                          key: locindex,
                          name: title,
                          value: title,
                          type: `underline`,
                          class: _normalizeClass(`fl mr10 mb10`),
                          display: true,
                          showDeleteButton: false,
                          onClickContent: ($event: any) => (_ctx.setTitleInfo(title))
                        }, null, 8, ["name", "value", "onClickContent"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_9
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "w100 borderGrey pad2 pointer mt20 rad8",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickOpenSubTitleView && _ctx.clickOpenSubTitleView(...args)))
              }, [
                _createElementVNode("h5", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_IconHelp, {
                    width: 18,
                    class: "fl mr10",
                    tooltipText: `ページタイトルが未設定の場合に利用するタイトルを設定します。`,
                    style: {"margin-top":"-3px","margin-right":"5px"}
                  }),
                  _createElementVNode("span", _hoisted_12, ":  " + _toDisplayString(_ctx.getTitle()), 1),
                  _hoisted_13
                ]),
                _hoisted_14
              ])),
          (![`editAppoAfterFixed`, `editAppoAfterCanceled`].includes(_ctx.appoStatus))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createVNode(_component_MeetingTimeContent, {
                  from: _ctx.from,
                  appo: _ctx.currentAppo,
                  onUpdateAppo: _ctx.updateFromChild
                }, null, 8, ["from", "appo", "onUpdateAppo"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_18,
          _createVNode(_component_AvailableStepSizeContent, {
            class: "mt40",
            from: _ctx.from,
            autoSave: false
          }, null, 8, ["from"]),
          _hoisted_19,
          _createVNode(_component_AvailableDaysOfWeeksTable, {
            class: "mt40",
            showDeleteButton: true,
            displayAllAdows: false,
            from: _ctx.from,
            defaultTimezoneValue: _ctx.rs ? _ctx.rs.timezone_value : null,
            onChangeDefaultTimezone: _ctx.changeDefaultTimezone,
            onAddAdow: _ctx.addAdow
          }, null, 8, ["from", "defaultTimezoneValue", "onChangeDefaultTimezone", "onAddAdow"]),
          _hoisted_20,
          _createVNode(_component_MeetingSpanContent, {
            style: `padding:0;`,
            class: "mt40"
          }),
          _hoisted_21,
          (
                    _ctx.from != `room_settings` &&
                    _ctx.rm.currentRoom &&
                    _ctx.rm.currentRoom.is_owner &&
                    [_ctx.Appointment.typeAddNew, _ctx.Appointment.typeNew].includes(_ctx.appoStatus)
                )
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createVNode(_component_FixTypeButtons, {
                  appo: _ctx.appo,
                  onFixBy: _ctx.fixBy
                }, null, 8, ["appo", "onFixBy"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_25,
          (_ctx.from == `schedule_view` && ![`editAppoAfterCanceled`].includes(_ctx.appoStatus))
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("label", _hoisted_29, [
                  _createTextVNode(" 場所 "),
                  (
                            _ctx.rm.currentRoom && _ctx.rm.currentRoom.is_owner && _ctx.appo && _ctx.appo.location_select_type.includes(`selectable`)
                        )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "以下の場所候補からお相手が選択できます。"))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.Util.isBlank(_ctx.loctags))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (
                            (_ctx.rm.currentRoom && _ctx.rm.currentRoom.is_owner && _ctx.appoStatus == _ctx.Appointment.typeAddNew) ||
                            [_ctx.Appointment.typeNew].includes(_ctx.appoStatus)
                        )
                        ? (_openBlock(), _createElementBlock("label", {
                            key: 0,
                            class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround`),
                            style: {"padding":"4px 10px","margin-bottom":"5px"},
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.useSelectLocations && _ctx.useSelectLocations(...args)))
                          }, _hoisted_33))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_34,
                (_ctx.appo.location_select_type == `registrable`)
                  ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                      key: 1,
                      placeholder: "東京都千代田区飯田橋4-25-1 セントラルプラザ2F",
                      style: {"height":"50px"},
                      class: "fl fs14 roundForm mw100",
                      value: _ctx.getLocationName(),
                      onInputValue: _ctx.inputLocationName
                    }, null, 8, ["value", "onInputValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _hoisted_36,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appo.selectable_locations, (loctag, loctagindex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${loctag.id}${loctagindex}`,
                          class: "fl mr10 rad8 centered",
                          style: {"width":"80px"}
                        }, [
                          _createVNode(_component_LocationIcon, {
                            width: 80,
                            totalHeight: 110,
                            loctag: loctag,
                            canDelete: _ctx.appoStatus == `newAppo` || (_ctx.appoStatus == `addnewAppo` && _ctx.rm.currentRoom.is_owner),
                            useLocationIcon: true,
                            onDeleteLocation: _ctx.removeLoc
                          }, null, 8, ["loctag", "canDelete", "onDeleteLocation"]),
                          _hoisted_37,
                          (loctagindex == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, "デフォルト"))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])),
                _hoisted_39,
                false
                  ? (_openBlock(), _createElementBlock("section", _hoisted_40, [
                      _hoisted_41,
                      _hoisted_42,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationNames, (loc, locindex) => {
                        return (_openBlock(), _createBlock(_component_LblueListContent, {
                          key: locindex,
                          class: "fl",
                          name: loc,
                          value: loc,
                          type: `underline mr10 mb10`,
                          display: true,
                          showDeleteButton: false,
                          onClickContent: ($event: any) => (_ctx.setLocationInfo(loc))
                        }, null, 8, ["name", "value", "onClickContent"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _hoisted_43,
          _hoisted_44,
          _hoisted_45,
          (_ctx.from == `schedule_view`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _hoisted_47,
                _hoisted_48,
                _createVNode(_component_TextareaTag, {
                  placeholder: "当日の持ち物などを入力",
                  class: "fl fs14 roundForm mw100",
                  value: _ctx.getMemo(),
                  onInputValue: _ctx.inputMemo
                }, null, 8, ["value", "onInputValue"]),
                _hoisted_49,
                _hoisted_50,
                _hoisted_51
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_SelectLocationsModal, {
          loctags: _ctx.loctags,
          selectedLoctags: _ctx.currentAppo ? _ctx.currentAppo.selectable_locations : null,
          appo: _ctx.appo,
          onSaveLocations: _ctx.saveLocations
        }, null, 8, ["loctags", "selectedLoctags", "appo", "onSaveLocations"])
      ]))
    : _createCommentVNode("", true)
}